import React, {useState, useEffect, useRef} from 'react'
import { Box, 
    Divider,
    Flex,
    Input, 
    Text,
    FormControl, 
    FormLabel,
    InputGroup,
    InputLeftElement, 
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
    Spinner,
    FormErrorMessage,
    useToast
} from '@chakra-ui/react'
import { AiOutlineSearch } from "react-icons/ai";
import { MdAddCircle } from "react-icons/md";
import { GiCancel } from "react-icons/gi";
import axios from 'axios';
import { Auth } from './Auth';
import { useFormik } from "formik";
import * as Yup from "yup";

const customerValue= {
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
}

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const emailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
Yup.setLocale({
    string: {
      email: 'Invalid email format',
    },
  });
// member Yup Validation schema
const customerSchema = Yup.object({
    firstName: Yup.string().min(1, "First name must be at least 1 characters").required("Please enter your first name"),
    lastName: Yup.string().min(1, "Last name must be at least 1 characters").required("Please enter your last name"),
    email: Yup.string().matches(emailRegExp, 'Email is not valid').required("Please enter your email"),
    phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required("Please enter your phone number"),
   
  });

function CustomerAdd({renderSummary2}) {
    const [addCustomerToggle, setAddCustomerToggle] = useState(false)
    const [allCustomer, setAllCustomer] = useState({})
    const productContainer = useRef(null);
    const { isOpen, onOpen, onClose} = useDisclosure()
    // const [customerDetails, setCustomerDetails] = useState(customerDetailsValue)
    const [customerInfo, setCustomerInfo] = useState({})
    const [showContactInfo, setShowContactInfo] = useState(false)
    const [query, setQuery] = useState("");
    const toast = useToast()

    // #### FORMIK ####
    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: customerValue,
      validationSchema: customerSchema,
      onSubmit: (values, action) => {
        let data = JSON.stringify({
          "firstName": values.firstName,
          "lastName": values.lastName,
          "roleTypeId": "ADMIN",
          "email": values.email,
          "phone": values.phone
        });
        
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_RALCO_API_URL}/api/party`,
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': Auth()
          },
          data : data
        };
        
        axios.request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          toast({
            title: 'Customer Created Successfully',
            position: 'top',
            status: 'success',
            duration: 3000,
            isClosable: true,
          })
        })
        .catch((error) => {
          console.log(error);
          toast({
            title: 'Oops we are facing some temporary issue with your request',
            position: 'top',
            status: 'error',
            duration: 3000,
            isClosable: true,
          })
        });
          onClose()
          action.resetForm()
      },})
    //   functionality to hide product dropdown
    const handleClickOutside = (event) => {
        if (
        productContainer.current &&
        !productContainer.current.contains(event.target)
        ) {
        if (!event.target.tagName.toLowerCase().match(/input|label/)) {
            setAddCustomerToggle(false);
        }
        }
    };
    // Dropdown useEffect
    useEffect(() => {
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);

        // Unbind the event listener on cleanup
        return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Customer Handler
    const customerHandler = async (e) => {
        setAllCustomer({})
        e.stopPropagation()
        setAddCustomerToggle(true)
        // const response = await fetch(`${process.env.REACT_APP_RALCO_API_URL}/api/party/shopify/customer-list`,{method: 'POST'})
        // const data = await response.json()
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_RALCO_API_URL}/api/party`,
          headers: {
            Authorization: Auth()
           }
        };
        
        axios.request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          setAllCustomer(response.data.toReversed())
        })
        .catch((error) => {
          console.log(error);
        });
    }

    useEffect(() => {
      let temp = JSON.parse(window.sessionStorage.getItem('customer_data'))
      if(temp){
        setShowContactInfo(true)
        setCustomerInfo(temp)
      }
    }, [])



    // catch customer details handler
    // const addCustomerHandler = (e) =>  {
    //     setCustomerDetails({...customerDetails, [e.target.name] : e.target.value })
    // }
    
    // console.log(customerDetails, 'hello')


    // create customer handler 
    // const createCustomerHandler = () => {
    //     let data = JSON.stringify({
    //         "firstName": `${customerDetails.firstName}`,
    //         "lastName": `${customerDetails.lastName}`,
    //         "email": `${customerDetails.email}`,
    //         "phone": `${customerDetails.phone}`,
    //         "comment": "n/a"
    //       });
          
    //       let config = {
    //         method: 'post',
    //         maxBodyLength: Infinity,
    //         url: `${process.env.REACT_APP_RALCO_API_URL}/api/party/shopify/create-customer`,
    //         headers: { 
    //           'Content-Type': 'application/json',
    //           'Authorization': Auth()
    //         },
    //         data : data
    //       };
          
    //       axios.request(config)
    //       .then((response) => {
    //         console.log(JSON.stringify(response.data));
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //     setCustomerDetails(customerDetailsValue)
    //     onClose()
    // }
    // Customer Item Handler
    const customerItemHandler = (d) => {
      // adding partyId to session storage
        const myObjTest = JSON.parse(window.sessionStorage.getItem('order_summary'))
        myObjTest.enteredByPartyId = (d.id).toString()
            myObjTest.customerPartyId = (d.id).toString()
            sessionStorage.setItem('order_summary', JSON.stringify(myObjTest))

            setShowContactInfo(true)
            setAllCustomer({})
            setAddCustomerToggle(false)
            sessionStorage.setItem('customer_data',JSON.stringify({
              firstName: d.firstName,
              lastName: d.lastName,
              email: d.email,
              phone: d.phone,
              id: d.id
            }))
            setCustomerInfo({
              firstName: d.firstName,
              lastName: d.lastName,
              email: d.email,
              phone: d.phone,
              id: d.id
            })

        // let data = JSON.stringify({
        //     "shopifyCustomerId": `${d.id}`
        //   });
          
        //   let config = {
        //     method: 'post',
        //     maxBodyLength: Infinity,
        //     url: `${process.env.REACT_APP_RALCO_API_URL}/api/party/shopify-customer-detail`,
        //     headers: { 
        //       'Content-Type': 'application/json',
        //       'Authorization': Auth()
        //     },
        //     data : data
        //   };
          
        //   axios.request(config)
        //   .then((response) => {

        //     myObjTest.enteredByPartyId = (response.data.data.id).toString()
        //     myObjTest.customerPartyId = (response.data.data.id).toString()
        //     sessionStorage.setItem('order_summary', JSON.stringify(myObjTest))
        //     setShowContactInfo(true)
        //     setAllCustomer({})
        //     setAddCustomerToggle(false)
        //     setCustomerInfo({
        //     firstName: d.firstName,
        //     lastName: d.lastName,
        //     email: d.email,
        //     phone: d.phone,
        //     id: d.id

        //     })})
        //   .catch((error) => {

        //     console.log(error);
        //     setShowContactInfo(true)
        //     setAllCustomer({})
        //     setAddCustomerToggle(false)
        //     setCustomerInfo({
        //     firstName: d.firstName,
        //     lastName: d.lastName,
        //     email: d.email,
        //     phone: d.phone,
        //     id: d.id

        //     })});   
                
            setQuery("")
}
   
  return (
    <Box shadow={'md'} rounded={'md'} border={'1px'} borderColor={'gray.200'} p={4} my={5} bgColor={'rgba(255, 255, 255, 1)'} >
        <FormLabel fontSize={'20px'}>Customer</FormLabel>
    {showContactInfo  ?
        <>
        <Box rounded={'md'} bgColor={'#F1F2F4'} py={3} px={4}>
        <Flex justifyContent={'end'}>
   
            <GiCancel cursor={'pointer'} fontSize={'18px'} color={'#ed2b2a'} onClick={() => {
                const myObjTest = JSON.parse(window.sessionStorage.getItem('order_summary'))
                myObjTest.enteredByPartyId = ""
                myObjTest.customerPartyId = ""
                sessionStorage.setItem('order_summary', JSON.stringify(myObjTest))
                setShowContactInfo(false)
                renderSummary2(Math.random()  + 1)
                window.sessionStorage.removeItem('shipping_Address_payload')
                window.sessionStorage.removeItem('billing_Address_payload')
                window.sessionStorage.removeItem('customer_data')
            }}/>
      
        </Flex>
        <Text fontSize={'18px'} color={'blue.500'}>{ customerInfo && customerInfo?.firstName + " " + customerInfo?.lastName}</Text>
        <Divider borderColor={'black'} my={2}/>
        <Box>
            <Text >Contact information</Text>
            <Text >{customerInfo?.email}</Text>
            <Text>{customerInfo?.phone}</Text>
        </Box>
        {/* <Divider borderColor={'black'} my={2}/>
        <Box>
            <Text fontWeight={'semibold'}>Shipping address</Text>
            <Text>Dummy address</Text>
        </Box> */}
        </Box>
        </>
        :
      <FormControl>
        
        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <AiOutlineSearch fontSize={'18px'} color={'gray'}/>
          </InputLeftElement>
          <Input type="text" placeholder="Search..." borderColor={'#898f94'} _hover={{borderColor: '#898f94'}} onClick={(e) => customerHandler(e)} onChange={(e) => setQuery(e.target.value)} autoComplete={'off'}/>
        </InputGroup>
        {addCustomerToggle && 
           <Box
           ref={productContainer}
           position={"absolute"}
           zIndex={"99"}
           bgColor={"white"}
           width={"100%"}
           border="1px"
           borderColor="gray.300"
           rounded={"md"}
           maxHeight={`${window.innerHeight - 275}px`}
           overflowY={"scroll"}
           
         >
          <Flex justifyContent={'center'} rounded={'md'} alignItems={'center'} py={2} px={2} my={2} mx={2} bgColor={'#F1F6F9'} cursor={'pointer'} onClick={() => {
            setAddCustomerToggle(false)
            setAllCustomer({})
            onOpen()
          }}>
            <MdAddCircle color={'rgb(171,177,186)'} fontSize={'26px'}/>
            <Text fontSize={'16px'} ml={2}>Create a new customer</Text>
          </Flex>
          <Divider borderColor={'rgb(171,177,186)'}/>
          {Object.keys(allCustomer).length > 0 ?
            allCustomer?.filter((e) => (e.firstName + " " + e.lastName).toLowerCase()
            .includes(query.toLocaleLowerCase())).map((d,i) => {
                return(
                <Box key={i} py={2} px={2} my={2} mx={2} _hover={{bgColor: 'rgb(171,177,186,0.2)', cursor: 'pointer'}} rounded={'md'} onClick={() => {
                  customerItemHandler(d)
                  renderSummary2(d.quantity)
                  }}>
                    <Text>{d.firstName + ' ' + d.lastName}</Text>
                    <Text fontSize={'   13px'}>{d.email}</Text>
                </Box>
                )
            })
            :
            <Flex justifyContent={'center'} my={4}>
                <Spinner color='red.500'/>
            </Flex>
        }
         </Box>
        }
      </FormControl>
}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
        <ModalHeader textAlign={'center'}>Create a new customer</ModalHeader>
          <ModalCloseButton />
          <Divider borderColor={'black'}/>
          <ModalBody>
          <FormControl mt={4} isInvalid={errors.firstName && touched.firstName}>
            <FormLabel>First Name</FormLabel>
            <Input placeholder='Enter your first name' value={values.firstName} onChange={handleChange} onBlur={handleBlur} name='firstName' autoComplete="off" />
            {errors.firstName && touched.firstName ? (
            <FormErrorMessage>{errors.firstName}</FormErrorMessage>
            ) : null}
          </FormControl>

          <FormControl mt={4} isInvalid={errors.lastName && touched.lastName}>
            <FormLabel>Last Name</FormLabel>
            <Input placeholder='Enter your last name' value={values.lastName} onChange={handleChange} onBlur={handleBlur}  name='lastName' autoComplete="off" />
            {errors.lastName && touched.lastName ? (
            <FormErrorMessage>{errors.lastName}</FormErrorMessage>
            ) : null}
          </FormControl>

          <FormControl mt={4} isInvalid={errors.email && touched.email}>
            <FormLabel>Email</FormLabel>
            <Input placeholder='Enter your email address' value={values.email} onChange={handleChange} onBlur={handleBlur}  name='email' autoComplete="off" />
            {errors.email && touched.email ? (
            <FormErrorMessage>{errors.email}</FormErrorMessage>
            ) : null}
          </FormControl>

        <FormControl mt={4} isInvalid={errors.phone && touched.phone}>
            <FormLabel>Phone No.</FormLabel>
            <Input placeholder='Enter your contact no.' value={values.phone} onChange={handleChange} onBlur={handleBlur}  name='phone'  autoComplete="off"/>
            {errors.phone && touched.phone ? (
            <FormErrorMessage>{errors.phone}</FormErrorMessage>
            ) : null}
        </FormControl>

          </ModalBody>

          <ModalFooter>
            <Button colorScheme='red' mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme='whatsapp' mr={3} onClick={handleSubmit}>
              Create
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}

export default CustomerAdd